import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = t(
  (r, e) => /* @__PURE__ */ o.jsx(
    a,
    {
      ref: e,
      ...r,
      image: (s) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...s,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M10 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M8 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
            }
          )
        }
      )
    }
  )
);
i.displayName = "MoreIcon";
export {
  i as MoreIcon,
  i as default
};
//# sourceMappingURL=index.js.map
